import React from 'react';
import { BodyText, Tooltip } from '@block-explorer/ui';
import { ACCOUNT_DETAILS_PATH } from '../../router/paths';
import { HistoryLink } from '../history-link/history-link';
import Avatar from '../avatar/avatar';
import {
  AccountInfoResult,
  getAccountInfoLogo,
} from '@block-explorer/entities';
import { buildRouterPath } from '../../router/utils';
import { useTranslation } from 'react-i18next';
import TooltipWithExtendedInfo from '../tooltip-with-extended-info/tooltip-with-extended-info.tsx';

interface AccountInfoIconProps {
  publicKey: string;
  csprName?: string | undefined;
  logo: string | null;
  path: string;
}

export const AccountInfoIcon = ({
  publicKey,
  csprName,
  logo,
  path,
}: AccountInfoIconProps) => {
  const { t } = useTranslation();
  return (
    <TooltipWithExtendedInfo
      publicKey={publicKey}
      extendedLine={{ title: csprName, caption: t('CSPR.name') }}
    >
      <BodyText size={3} monotype>
        <HistoryLink href={path}>
          {logo ? (
            <Avatar src={logo} size={'tiny'} alt={'Account logo'} />
          ) : (
            <Avatar hash={publicKey} size={'tiny'} />
          )}
        </HistoryLink>
      </BodyText>
    </TooltipWithExtendedInfo>
  );
};

interface ExtendedAccountInfoIconProps {
  publicKey: string;
  getAccountInfo?: (publicKey: string) => AccountInfoResult | null | undefined;
}

export const ExtendedAccountInfoIcon = ({
  publicKey,
  getAccountInfo,
}: ExtendedAccountInfoIconProps) => {
  if (getAccountInfo === undefined) {
    return null;
  }

  const accountInfo = getAccountInfo(publicKey);
  const logo = getAccountInfoLogo(accountInfo);
  const path = buildRouterPath(
    ACCOUNT_DETAILS_PATH,
    { id: publicKey },
    undefined
  );

  return (
    <Tooltip title={publicKey}>
      <BodyText size={3} monotype>
        <HistoryLink href={path}>
          {logo ? (
            <Avatar src={logo} size={'tiny'} alt={'Account logo'} />
          ) : (
            <Avatar hash={publicKey} size={'tiny'} />
          )}
        </HistoryLink>
      </BodyText>
    </Tooltip>
  );
};
